import { EntityType } from "@mapmycustomers/shared/enum";
import Route from "@mapmycustomers/shared/types/entity/Route";
import { EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity/types";

const getRouteStopsTypes = (route: Route): EntityTypesSupportingRoutes[] => {
  const stops = route.stopTime ?? [];
  const types: EntityTypesSupportingRoutes[] = [];
  if (stops.some((stop) => stop.entity === EntityType.COMPANY)) {
    types.push(EntityType.COMPANY);
  }
  if (stops.some((stop) => stop.entity === EntityType.PERSON)) {
    types.push(EntityType.PERSON);
  }
  return types;
};

export default getRouteStopsTypes;
